export enum Role {
    ROLE_USER = 'ROLE_USER',
    ROLE_ADMIN = 'ROLE_ADMIN',
    ROLE_ADMIN_LIQUIDACION = 'ROLE_ADMIN_LIQUIDACION'
  }
  
